import { MapPin, Phone, Mail, Facebook, Instagram, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import React, { useState } from 'react';
import { toast } from "sonner";
import { EmailApi } from "@/api/api";

const Footer = () => {

  const quickLinks = [
    { label: "Trang chủ", to: "/" },
    { label: "Thương hiệu", to: "/thuong-hieu" },
    { label: "Sản phẩm", to: "/san-pham" },
    { label: "Sharing Blog", to: "/sharing-blog" },
    { label: "Liên hệ", to: "/lien-he" },
    { label: "Giỏ hàng", to: "/cart" },
  ];

  const policyLinks = [
    { label: "Chính sách đổi trả", to: "/chinh-sach" },
    { label: "Chính sách bán hàng", to: "/chinh-sach" },
    { label: "Chính sách bảo mật", to: "/chinh-sach" },
    { label: "Chính sách giao hàng", to: "/chinh-sach" },
  ];

  return (
      <footer className="bg-primary text-primary-foreground">
        <div className="container mx-auto px-4 py-16">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8 lg:gap-10">
            <div>
              <h3 className="text-2xl font-heading mb-6 text-accent">Memys</h3>
              <div className="space-y-3 text-sm">
                <div className="flex items-start gap-2">
                  <MapPin size={16} className="mt-0.5 flex-shrink-0 text-accent" />
                  <span>279 Nguyễn Tri Phương, Phường Diên Hồng, Thành phố Hồ Chí Minh</span>
                </div>
                <div className="flex items-center gap-2">
                  <Phone size={16} className="flex-shrink-0 text-accent" />
                  <span>0842.1141.225</span>
                </div>
                <div className="flex items-center gap-2">
                  <Mail size={16} className="flex-shrink-0 text-accent" />
                  <span>memysvietnam@gmail.com</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-sm text-accent font-semibold tracking-wider uppercase mb-6">Hỗ trợ khách hàng</h4>
              <ul className="space-y-2 text-sm text-primary-foreground/80">
                {quickLinks.map((link) => (
                    <li key={link.label}>
                      <Link to={link.to} onClick={() => window.scrollTo(0, 0)} className="hover:text-accent transition-colors">{link.label}</Link>
                    </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm text-accent font-semibold tracking-wider uppercase mb-6">Chính sách</h4>
              <ul className="space-y-2 text-sm text-primary-foreground/80">
                {policyLinks.map((link) => (
                    <li key={link.label}>
                      <Link to={link.to}
                            onClick={() => window.scrollTo(0, 0)}
                            state={{ targetPolicy: link.label }}
                            className="hover:text-accent transition-colors">{link.label}
                      </Link>
                    </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm text-accent font-semibold tracking-wider uppercase mb-6">Tổng đài hỗ trợ</h4>
              <div className="space-y-3 text-sm text-primary-foreground/80">
                <p>
                  Mua hàng online:<br/>
                  <span className="font-semibold text-accent text-base">0842 1141 225</span>
                </p>
                <p>
                  Góp ý và khiếu nại:<br/>
                  <span className="font-semibold text-accent text-base">1900 3010</span>
                </p>
              </div>
            </div>

            <div>
              <h4 className="text-sm text-accent font-semibold tracking-wider uppercase mb-6">Kết nối với Memys</h4>
              <div className="flex items-center gap-3">
                <a
                    href="https://www.facebook.com/memysvietnam"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Truy cập trang Facebook của Memys Vietnam"
                    className="w-10 h-10 rounded-full bg-primary-foreground/10 flex items-center justify-center text-primary-foreground hover:bg-accent hover:text-accent-foreground transition-all"
                >
                  <Facebook size={20} />
                </a>
                <a
                    href="https://www.instagram.com/memys.vietnam"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Truy cập trang Instagram của Memys Vietnam" 
                    className="w-10 h-10 rounded-full bg-primary-foreground/10 flex items-center justify-center text-primary-foreground hover:bg-accent hover:text-accent-foreground transition-all"
                >
                  <Instagram size={20} />
                </a>
              </div>
            </div>

          </div>
        </div>

        <div className="border-t border-primary-foreground/10 py-6">
          <p className="text-center text-xs text-primary-foreground/60">
            Copyright © 2026 Memys | Thương hiệu thuộc về Memys
          </p>
        </div>
      </footer>
  );
};

export default Footer;